import React, { useContext, useEffect, useState } from "react";
import SocketContext from "../../../../../context/SocketContext";

export default function LiveRate(props) {
  const socket = useContext(SocketContext);

  const symbol_id = props.symbol_id;
  const buy_sell = props.buy_sell;

  const [Ask, setAsk] = useState(0);
  const [Bid, setBid] = useState(0);
  const [LTP, setLTP] = useState(0);

  useEffect(() => {
    socket.emit("giverate", symbol_id);
    socket.on("trade" + symbol_id, trade);
    return () => {
      socket.off("trade" + symbol_id, trade);
    };
  }, [socket, symbol_id]);

  const trade = (data) => {
    if (data) {
      setAsk(data.Ask);
      setBid(data.Bid);
      setLTP(data.LTP);
    }
  };

  /** ⭐ Final price with fallback */
  const finalBid = Bid === 0 ? LTP : Bid;
  const finalAsk = Ask === 0 ? LTP : Ask;

  return (
    <div className={`menuBuyPrice large`}>
      {buy_sell === 0 ? parseFloat(finalBid) : parseFloat(finalAsk)}
    </div>
  );
}
